import { blogPostsApi } from "@/apis/apis";
import { BannerPreviewModal } from "@/components/BannerEditorModal/BannerPreviewModal";
import ImageWithFallback from "@/components/ImageWithFallback";
import StatusBadge from "@/components/StatusBadge";
import { DefaultIcon } from "@/constant/imagePath";
import { DEFAULT_LANGUAGE_LABEL } from "@/constant/Languages/language";
import { formatDateTime } from "@/utils/helper";

export const columns = () => {
  return [
    {
      accessorKey: "default_status",
      header: `Status (${DEFAULT_LANGUAGE_LABEL})`,
      cell: ({ row }) => (
        <StatusBadge status={row.getValue("default_status")} />
      ),
    },
    {
      accessorKey: "sport.code",
      header: "Sport ID",
    },
    {
      id: "created_at",
      accessorFn: (row) => formatDateTime(row.created_at, true),
      header: `Date Added`,
    },
    {
      id: `default_title`,
      accessorFn: (row) =>
        row.default_title?.length > 70
          ? `${row.default_title.slice(0, 70)}...`
          : row.default_title,
      header: `Title (${DEFAULT_LANGUAGE_LABEL})`,
    },
    {
      accessorKey: "category.name",
      header: "Category",
    },
    {
      accessorKey: "thumbnail_url",
      header: "Thumbnail",
      cell: ({ row }) => (
        <ImageWithFallback
          url={row.getValue("thumbnail_url")}
          thumbnailSrc={DefaultIcon}
          className={"h-5"}
        />
      ),
      enableResizing: false,
      enableSorting: false,
    },
    {
      accessorKey: "banner_url",
      header: "Banner",
      cell: ({ row }) =>
        row.original?.banner_url && (
          <BannerPreviewModal
            api={blogPostsApi}
            data={row.original}
            image_url={row.original?.banner_url}
          />
        ),
      enableResizing: false,
      enableSorting: false,
    },
    {
      accessorKey: "number_of_active_languages",
      header: `# Active Languages`,
      enableSorting: false,
    },
    {
      id: "default_last_change.date",
      accessorFn: (row) => formatDateTime(row.default_last_change?.date),
      header: `Last Change`,
    },
    {
      accessorKey: "default_last_change.by",
      header: `Last Change By`,
    },
    {
      accessorKey: "total_likes",
      header: "Likes",
      cell: ({ row }) => <div>{row.original.likes?.total_likes || 0}</div>,
    },
    {
      accessorKey: "total_share",
      header: "Shares",
      cell: ({ row }) => <div>{row.original.shares?.total_shares || 0}</div>,
    },
    {
      accessorKey: "total_views",
      header: "Views",
      cell: ({ row }) => <div>{row.original.views?.total_views || 0}</div>,
    },
  ];
};
